

import { useMutation} from 'react-query';
import {client} from './ApiClient';
import {EGiftRecipient} from "../EGiftCard/EGiftCardSnippet";
import {EGiftCard} from "../Helpers/Types";
import {roundToCents, standardizeEGiftCard} from "../EGiftCard/EGiftCardRules";
import {SnippetAuth} from "./SnippetAuth";

const mapCardAmounts = (cards: Array<EGiftCard>): Array<any> => {
    return cards.map(standardizeEGiftCard).map(c => {
        const amount = c.Amount === 'Custom' ? c.CustomAmount ?? 0 : parseFloat(c.Amount)
        return {...c, Amount: isNaN(amount) ? c.Amount : roundToCents(amount).toString(), SendDate: c.SendDate.format("YYYY-MM-DD")}
    })
}

// The cart comes from the snippet session (created on the first save), so no cart id is sent.
const setEGiftCards = ({urls, auth, lineUid, productCode, snippetProfileCode, cards }: {urls: any; auth: SnippetAuth | undefined; lineUid: string; productCode: string; snippetProfileCode: string; cards: Array<EGiftCard>}) => {
    if (!auth)
        return Promise.reject('A snippet session key is required.')

    return client(urls.LoyaltyEngineApiUrl, 'v5/snippets/carts/commands/setegiftcards', {
        ...auth,
        body: {
            LineUid: lineUid,
            ProductCode: productCode,
            Details: {
                GiftCards: mapCardAmounts(cards),
                // Required by the Loyalty Engine: the profile's MinValue/MaxValue limit the amounts.
                SnippetProfileCode: snippetProfileCode
            }
        }
    });
}

export default function useSetEGiftCards() {
    // @ts-ignore
    return useMutation(setEGiftCards)
}